module.exports = __webpack_public_path__ + "static/media/Amazon.56c1c97a.svg";